import { App } from "vue";
import { createNaverMap } from "vue3-naver-maps";

const CLINET_ID = "mr9028hsnu";

export default function install(app: App<Element>) {
  app.use(createNaverMap, { clientId: CLINET_ID });
}
